import { render, staticRenderFns } from "./SubgroupNameListGroupSelectForm.vue?vue&type=template&id=4b2025e0&"
import script from "./SubgroupNameListGroupSelectForm.vue?vue&type=script&lang=js&"
export * from "./SubgroupNameListGroupSelectForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports